import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import accounts from 'accounts/Accounts.js';
import React, { Component } from 'react';
import PasswordMask from 'react-password-mask';
import ConditionedComponent from 'components/ConditionedComponent.js';
import { connect } from "react-redux";
import {setShowPasswordModal} from 'actions/index.js';
import EffectMods from 'components/effects/EffectMods.js';
import {  InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import '../../Modals.scss';
import ethereum from 'decentralized/ethereum.js';

/**
 * Modal responsible for sequence-wide changes like
 * double setting the track length
 */
class PasswordModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            incorrectPassword: false,
            needsToSetPassword: false,
            userName: undefined,
        };

        this.onClickDone = this.onClickDone.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.show && nextProps.show !== this.props.show) {
            this.getNeedsToSetPassword();
            this.getUserName();
        }
        return true;
    }

    async getUserName() {
        this.setState({
            userName: await accounts.getUserName()
        });
    }

    async getNeedsToSetPassword() {
        let publicKey = await ethereum.encryption.getPublicKey();
        console.log('ethereum.getPublicKey() returned = ');
        console.log(publicKey);
        if (publicKey === undefined) { 
            this.setState({needsToSetPassword: true});
        }
    }

    componentDidUpdate(newProps) {
        if (newProps.show !== this.props.show) {
            console.log('password input = ');
            console.log(this.input.passwordInput);
            this.input.passwordInput.focus();
        }
        return true;
    }

    async onClickDone() {
        if (!(await this.props.crypto.isCorrectPassword(this.state.password))) {
            this.setState({
                incorrectPassword: true
            });
            return;
        } else {
            this.setState({
                incorrectPassword: false,
            });
        }
        this.props.setShowPasswordModal(false);
        console.log('passwordModalCallback(' + this.state.password + ')');
        this.props.passwordModalCallback(this.state.password);
    }

    onClickCancel() {
        this.props.passwordModalCallback(undefined);
        this.props.setShowPasswordModal(false);
    }

    handleChange(x) {
        this.setState({password: x.target.value});
    }

    onKeyDown(e) {
        if (e.key === 'Enter') {
            this.onClickDone();
        }
    }

    render() {
        return (
            <Modal
              dialogClassName="preset-modal"
              show={this.props.show}
              onHide={() => this.props.setShowPasswordModal(false)}>
              <Modal.Body>
                <ConditionedComponent condition={this.state.incorrectPassword}>
                  <div className="incorrect-password">Incorrect password</div>
                </ConditionedComponent>
                <ConditionedComponent condition={this.state.userName !== undefined}>
                  Password required to access
                  <div className="password-user-name">
                    {this.state.userName}
                  </div>
                </ConditionedComponent>
                <ConditionedComponent condition={this.state.needsToSetPassword}>
                  Create a password to be used to encrypt your projects. Remember the password you choose.
                </ConditionedComponent>
                <div className="password-container">
                  <PasswordMask
                    id="password"
                    name="password"
                    placeholder="Enter password"
                    onKeyDown={(x) => this.onKeyDown(x)}
                    ref={(input) => this.input = input}
                    value={this.state.password}
                    onChange={this.handleChange.bind(this)}
                    />
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={this.onClickDone}>
                  Done
                </Button>
                <Button variant="primary" onClick={this.onClickCancel}>
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setShowPasswordModal: show => dispatch(setShowPasswordModal(show)),
    }
};

const mapStateToProps = state => {
    return {
        show : state.sequencer.showPasswordModal,
        passwordModalCallback: state.sequencer.passwordModalCallback,
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(PasswordModal);

